@if (reportTitlePageData(); as reportTitlePageData) {
  <div class="d-flex color-line"></div>
  <div class="d-flex flex-column flex-grow-1 mb-4">
    <br />
    <table class="w-100">
      <tbody>
        <tr>
          <td class="color-blue-background header-padding">
            <img src="app/assets/img/logo_black.svg" alt="logo" height="35" class="ms-3 m-2" />
          </td>
          <td class="color-blue-background header-padding"></td>
          <td class="color-blue-background header-padding text-right pe-3">
            <h4 [attr.data-cy]="'report-title-page-header-text'">{{ reportTitlePageData.headerText | translate }}</h4>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex flex-column flex-grow-3">
    <div class="ms-3 m-2">
      <h1 class="font-weight-bold ms-3" [attr.data-cy]="'report-title-page-title'">
        {{ reportTitlePageData.title | translate }}
      </h1>
      <h3 class="ms-3" [attr.data-cy]="'report-title-page-subtitle'">
        {{ reportTitlePageData.subtitle | translate }}
      </h3>
      <br />
      <br />
      @if (reportTitlePageData.description) {
        <div class="text-justify" [attr.data-cy]="'report-title-page-description'">
          {{ reportTitlePageData.description | translate }}
        </div>
      }
      <ng-content></ng-content>
    </div>
  </div>
  <div class="d-flex flex-column">
    <div class="ms-3 m-2" [attr.data-cy]="'report-title-page-footer-text'">
      {{ reportTitlePageData.footerText | translate }}
    </div>
    <br />
  </div>
  <div class="d-flex color-line"></div>
}
